import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Dashboard from "./components/Dashboard/Dashboard";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Login from "./components/Login";
import { useSelector } from "react-redux";
import { useEffect, useLayoutEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Users from "./components/Users";
import UsersWithNoWebsites from "./components/UsersWithNoWebsites";
import Websites from "./components/Websites";
import WebsitesUserSelected from "./components/WebsitesUserSelected";
import ChangePassword from "./components/ChangePassword";
import ForgetPassword from "./components/ForgetPassword";
import ResetPassword from "./components/ResetPassword";
import Footer from "./components/Footer";
import Subscriptions from "./components/subscriptions/Subscriptions";
import PricingPlans from "./components/PricingPlans/PricingPlans";
import EditSubscription from "./components/subscriptions/EditSubscription";
import AddSubscription from "./components/subscriptions/AddSubscription";
import Stripe from "./components/Stripe";
import NewStripeProduct from "./components/NewStripeProduct";

function App() {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !token &&
      window.location.pathname !== "/forget-password" &&
      !window.location.pathname.includes("reset-password")
    ) {
      navigate("/login");
    } else if (token && window.location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [token]);

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  return (
    <div className="">
      {token ? (
        <Wrapper>
          <div className="flex">
            <div className="">
              <Sidebar />
            </div>
            <div className="w-full">
              <div className="content-container w-full">
                <main>
                  <div className="flex flex-row">
                    <div className="w-full">
                      <Navbar />

                      <div className="2xl:px-10 xl:px-10 lg:px-10 md:px-6 px-3 py-5">
                        <Routes>
                          <Route
                            exact
                            path="/dashboard"
                            element={<Dashboard />}
                          />
                          <Route exact path="/users" element={<Users />} />
                          <Route
                            exact
                            path="/websites"
                            element={<Websites />}
                          />
                          <Route
                            exact
                            path="/change-password"
                            element={<ChangePassword />}
                          />
                          <Route
                            path="/users-selected-websites"
                            element={<WebsitesUserSelected />}
                          />
                          <Route
                            path="/users-no-websites"
                            element={<UsersWithNoWebsites />}
                          />
                          <Route path="/payments" element={<Subscriptions />} />
                          <Route path="/plan" element={<PricingPlans />} />
                          <Route path="/stripe" element={<Stripe />} />
                          <Route
                            path="/stripe/new"
                            element={<NewStripeProduct />}
                          />
                          <Route
                            path="/subscription/edit/:id"
                            element={<EditSubscription />}
                          />
                          <Route
                            path="/subscription/add"
                            element={<AddSubscription />}
                          />
                        </Routes>
                      </div>
                    </div>
                  </div>
                </main>
              </div>

              <footer className="footer--pin">
                <Footer />
              </footer>
            </div>
          </div>
        </Wrapper>
      ) : (
        <div className="py-5">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password/:id" element={<ResetPassword />} />
          </Routes>
        </div>
      )}
      <ToastContainer />
    </div>
  );
}

export default App;
